module.exports = __webpack_public_path__ + "static/media/giveswap_logo_dark.f51bad61.png";